/**
 * Copyright Mántum All Rights Reserved.
 */
import Form from '../../kanela';
import fetcher from '../../adapter/fetcher';
import useSWR from 'swr';
import { forwardRef } from 'react';

import type {
    Action,
    Kanela as Component,
    Sections,
    Tabs
} from '@mantum/kanela';

type PropTypes = {
    action?: Action;
    entity?: string | number;
    env?: Record<string, unknown>;
    onClick?: (name?: string, value?: unknown) => void;
    options?: Sections | Tabs;
};

export default forwardRef<Component, PropTypes>(function Detail(props, ref) {
    // prettier-ignore
    const {
        entity = ''
    } = props

    const dataSource = {
        ...props.action?.load?.dataSource
    };

    const internal = (url: string) =>
        fetcher(url, {
            namespace: dataSource?.namespace,
            parameter: dataSource?.parameter
        });

    const { data } = useSWR(
        () =>
            dataSource
                ? dataSource?.url?.replace('{entity}', `${entity}`)
                : null,
        internal
    );

    const mode = entity !== '' ? 'load' : 'create';
    const values =
        typeof data === 'object' && !Array.isArray(data) ? data : undefined;

    return (
        <Form
            env={props.env}
            mode={mode}
            onClick={props.onClick}
            options={props.options}
            ref={ref}
            values={values}
        />
    );
});
